export default __webpack_public_path__ + "static/media/1604.eb1d3074.png";